/**
 * Configuración para la integración con UAU Auth
 */

// Obtener configuración de variables de entorno
const UAU_AUTH_URL = import.meta.env.VITE_UAU_AUTH_URL || 'http://localhost:8100/api/v1';
const UAU_APPLICATION_SLUG = import.meta.env.VITE_UAU_APPLICATION_SLUG || 'mava1-forestry';

export const UAU_CONFIG = {
  // URLs del servicio UAU
  BASE_URL: UAU_AUTH_URL,
  ENDPOINTS: {
    LOGIN: `${UAU_AUTH_URL}/auth/login`,
    LOGOUT: `${UAU_AUTH_URL}/auth/logout`,
    ME: `${UAU_AUTH_URL}/auth/me`,
    PERMISSIONS_CHECK: `${UAU_AUTH_URL}/permissions/check`,
    REFRESH: `${UAU_AUTH_URL}/auth/refresh`,
  },
  
  // Configuración de la aplicación
  APPLICATION_SLUG: UAU_APPLICATION_SLUG,
  
  // Configuración de tokens
  TOKEN_CONFIG: {
    DEFAULT_EXPIRES_IN: 1800, // 30 minutos
    REFRESH_BUFFER_TIME: 5 * 60 * 1000, // 5 minutos antes de expirar
  },
  
  // Claves de localStorage
  STORAGE_KEYS: {
    TOKEN: 'mava_token',
    REFRESH_TOKEN: 'mava_refresh_token',
    USER: 'mava_user',
    PERMISSIONS: 'mava_permissions',
    TOKEN_EXPIRY: 'mava_token_expiry',
  },
  
  // Headers por defecto
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  
  // Headers para login (form-encoded)
  LOGIN_HEADERS: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Accept': 'application/json',
  },
  
  // Configuración de timeouts
  TIMEOUTS: {
    REQUEST_TIMEOUT: 10000, // 10 segundos
    LOGIN_TIMEOUT: 15000,   // 15 segundos para login
  },
  
  // Configuración de reintentos
  RETRY_CONFIG: {
    MAX_RETRIES: 3,
    RETRY_DELAY: 1000, // 1 segundo
  },
  
  // Debug mode
  DEBUG: import.meta.env.VITE_DEBUG === 'true',
} as const;

/**
 * Helper para logging con debug condicional
 */
export const uauLogger = {
  info: (message: string, ...args: any[]) => {
    if (UAU_CONFIG.DEBUG) {
      console.log(`🔐 UAU: ${message}`, ...args);
    }
  },
  
  success: (message: string, ...args: any[]) => {
    if (UAU_CONFIG.DEBUG) {
      console.log(`✅ UAU: ${message}`, ...args);
    }
  },
  
  error: (message: string, ...args: any[]) => {
    console.error(`❌ UAU: ${message}`, ...args);
  },
  
  warn: (message: string, ...args: any[]) => {
    if (UAU_CONFIG.DEBUG) {
      console.warn(`⚠️ UAU: ${message}`, ...args);
    }
  },
};

/**
 * Validar configuración UAU
 */
export const validateUAUConfig = (): boolean => {
  const requiredEnvVars = {
    'VITE_UAU_AUTH_URL': UAU_AUTH_URL,
    'VITE_UAU_APPLICATION_SLUG': UAU_APPLICATION_SLUG,
  };
  
  let isValid = true;
  
  Object.entries(requiredEnvVars).forEach(([key, value]) => {
    if (!value || value.includes('undefined')) {
      uauLogger.error(`Variable de entorno requerida no configurada: ${key}`);
      isValid = false;
    }
  });
  
  if (isValid) {
    uauLogger.success('Configuración UAU validada correctamente');
  }
  
  return isValid;
};

export default UAU_CONFIG;
